import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SearchBox from "../search/SearchBox";
import axios from "axios";

// 페이징1
import Pagination from '../base/Pagination';

const parseJwt = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            window
                .atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
};
export default function UserList() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [keyword, setKeyword] = useState("");
    const [userList, setUserList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const token = localStorage.getItem("token");
    const user = token ? parseJwt(token) : null;
    const isSuperAdmin = user?.auth === 1;

    //페이징2
    const pageFromUrl = Number(searchParams.get("page"));
    const currentPage = Number.isInteger(pageFromUrl) && pageFromUrl > 0 ? pageFromUrl : 1;
    const logsPerPage = 6;

    const changePage = (page) => {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.set("page", String(page));
        setSearchParams(nextParams);
    };

    const fetchUserList = async () => {
        try {
            console.log('token : ', token)
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/user`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log("사용자 목록 불러오기 성공:", response.data);
            if (Array.isArray(response.data.user)) {
                setUserList(response.data.user);
                setFilteredList(response.data.user);
            } else {
                console.warn("user 목록이 배열이 아님:", response.data);
                setUserList([]);
                setFilteredList([]);
            }
        } catch (error) {
            console.error("사용자 목록 불러오기 실패:", error);
            setUserList([]);
            setFilteredList([]);
        }
    };

    useEffect(() => {
        fetchUserList();
    }, []);

    const handleSearch = () => {
        const trimmedKeyword = keyword.trim().toLowerCase();

        if (trimmedKeyword === "") {
            setFilteredList(userList);
        } else {
            const filtered = userList.filter(
                (user) =>
                    user.name?.toLowerCase().includes(trimmedKeyword) ||
                    user.address?.toLowerCase().includes(trimmedKeyword) ||
                    user.detail_address?.toLowerCase().includes(trimmedKeyword) ||
                    user.age?.toString().toLowerCase().includes(trimmedKeyword) ||
                    user.sex?.toLowerCase().includes(trimmedKeyword) ||
                    user.sev_name?.toLowerCase().includes(trimmedKeyword) ||
                    user.department_name?.toLowerCase().includes(trimmedKeyword) ||
                    user.pec?.toLowerCase().includes(trimmedKeyword)
            );
            setFilteredList(filtered);
        }
        changePage(1);
    };

    const handleReset = () => {
        setKeyword("");
        setFilteredList(userList);
        changePage(1);
    };

    const handleClick = (user) => {
        navigate(`/user/${user.id}`);
    };

    // 페이징3
    const indexOfLastLog = currentPage * logsPerPage;
    const indexOfFirstLog = indexOfLastLog - logsPerPage;
    const currentLogs = filteredList.slice(indexOfFirstLog, indexOfLastLog); // filteredList 표 값이랑 맞추기
    const totalPages = Math.ceil(filteredList.length / logsPerPage);

    return (
        <div className="user">
            <h1>전체 사용자 관리</h1>
            <div className="user_box">
                <SearchBox
                    keyword={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    onSearch={handleSearch}
                    onReset={handleReset}
                />
                <div className="user_list">
                    <div className="table">
                        <table>
                            <colgroup>
                                <col width="7%" />
                                <col width="*" />
                                <col width="7%" />
                                <col width="7%" />
                                <col width="16%" />
                                <col width="12%" />
                                <col width="12%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col">이름</th>
                                    <th scope="col">주소</th>
                                    <th scope="col">나이</th>
                                    <th scope="col">성별</th>
                                    <th scope="col">지병</th>
                                    <th scope="col">위험군 등급</th>
                                    <th scope="col">담당 관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentLogs.map((user) => (
                                    <tr
                                        key={user.id}
                                        onClick={() => handleClick(user)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <td>{user.name || "-"}</td>
                                        <td>
                                            {(user.address?.trim() ? user.address : "-")}{" "}
                                            {(user.detail_address?.trim())}
                                        </td>
                                        <td>{user.age != null ? `만 ${user.age}세` : "-"}</td>
                                        <td>{user.sex || "-"}</td>
                                        <td>{user.pec || "-"}</td>
                                        <td>{user.sev_name || "-"}</td>
                                        <td>{user.department_name || "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={changePage}
                />
                <div className="btn-group">
                    {isSuperAdmin && (<button onClick={() => navigate("/user/new")} className="btncolor01">등록</button>)}
                </div>
            </div>
        </div>
    );
}
